import { useEffect, ReactNode } from 'react';

import { getCurrentSize, setWindowSize } from './windowSize.context';

export function WindowSizeProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    function handleResize(): void {
      setWindowSize(getCurrentSize());
    }

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return <>{children}</>;
}
